import i18n from 'src/i18n';

export const ACCOUNTBLOCKCATEGORY = {
    orderBlock: [{ '01': '' }],
};
export const SETTIMEOUTVALUE = '2000';
export const CREDITCARDPAYMENTMESSAGE = () =>
    i18n.t('equity.common.constants.creditCardMsg');
export const CONSIGNMENTADDVALIDATEACCOUNT = {
    orderType: 'KB',
    sapPartnerId: '',
    soldtoId:'',
    district: '',
    territory: '',
};

export const CONTACTNUMBERVALIDATIONMESSAGE = () =>
    i18n.t('consignment.contactInfo.contactNumber.contactValidationMessage');
export const CONSIGNMENT_ADD_ORDERTYPE = 'KB';

export const BASESITEID = 'mdt_b2bsite_us';

export const CONSIGNMENT_ADD_PRODUCT_TEMPLATE_VALIDATION_POPUPMESSAGES =
    () => ({
        itemNotAvailable: (count) => {
            return {
                title: i18n.t('equity.common.constants.items'),
                heading1: `${count} ${i18n.t(
                    'equity.common.constants.itemsCart'
                )}`,
                heading2: i18n.t('equity.common.constants.itemsCannot'),
                customerServiceMessage: '',
            };
        },
        tenItemTitle: i18n.t('equity.common.constants.items'),
        itemNotAllowedAsExtra: i18n.t(
            'ConsignmentAdd.common.bundleItems.constants.templateContainsItemsNotAllowed'
        ),
    });

export const CONSIGNMENT_ADD_PRODUCT_VALIDATION_POPUPMESSAGES = () => ({
    itemNotAvailable: () => {
        return {
            title: i18n.t('equity.common.constants.items'),
            heading1: '',
            heading2: i18n.t('equity.common.constants.itemsEquity'),
            customerServiceMessage: i18n.t(
                'equity.common.constants.customerServices'
            ),
        };
    },
    tenItemTitle: i18n.t('equity.common.constants.items'),
    itemNotAllowedAsExtra: i18n.t(
        'ConsignmentAdd.common.bundleItems.constants.templateContainsItemsNotAllowed'
    ),
});

export const ITEMSDETAILS = [
    { salesOrg: { tissue: 'S030', nonTissue: 'S002' } },
    {
        priceType: {
            extPrice: 'extPrice',
            adjustedExtPrice: 'adjustedExtPrice',
        },
    },
    { materialType: { bundle: 'ZKMT' } },
];

export const SCREENNAMES = ['Account', 'Cart', 'Shipping', 'Details'];
export const RESPONSESUCCESS = '10001';
export const RESPONSEFAILURE = 'Server not available';
export const PRODUCTSNOTFOUNDCODE = '10201';

export const SORTORDER = {
    asc: 'ASC',
    desc: 'DESC',
};

export const UNKNOWNID = 'Unknown';
export const ALLDISTRICTS = 'ALL_Districts';
export const ALLTERRITORIES = 'All_Territories';
export const PRODUCTDETAILS = {
    itemProductKey: '',
    subItemProductKey: '',
};
